import script from "./VPriority.vue?vue&type=script&setup=true&lang=js"
export * from "./VPriority.vue?vue&type=script&setup=true&lang=js"

import "./VPriority.vue?vue&type=style&index=0&id=4844c3fe&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4844c3fe"]])

export default __exports__